import {BurialService} from './burial-service'
import {ProfileService} from './profile-service'
import {AuthService} from './auth-service'
import {DocumentsService} from './documents-service'
import {FileService} from './file-service'
import {ContactsService} from './contacts-service'
import {InvitationsService} from './invitations-service'
import {GuardiansService} from './guardians-service'
import {ProtegesService} from './proteges-service'
import {CeremonyService} from './ceremony-service'
import {PetsService} from './pets-service'
import {SpeechesService} from './speeches-service'
import {UserService} from './user-service'
import {MusicsService} from './musics-service'

const API = {
    ...BurialService,
    ...ProfileService,
    ...AuthService,
    ...DocumentsService,
    ...FileService,
    ...ContactsService,
    ...InvitationsService,
    ...GuardiansService,
    ...ProtegesService,
    ...CeremonyService,
    ...PetsService,
    ...SpeechesService,
    ...UserService,
    ...MusicsService
}

export default API



// WEBPACK FOOTER //
// ./src/services/API.js